var React = require('react');

function CloseBtn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.417 3.398A1.99 1.99 0 0 0 13.602.583L8.5 5.685 3.398.583A1.99 1.99 0 0 0 .583 3.398L5.685 8.5.583 13.602a1.99 1.99 0 0 0 2.815 2.815L8.5 11.315l5.102 5.102a1.99 1.99 0 0 0 2.815-2.815L11.315 8.5l5.102-5.102z","fill":"#FFF","fillRule":"nonzero"}));
}

CloseBtn.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17"};

module.exports = CloseBtn;

CloseBtn.default = CloseBtn;
